import * as Sentry from '@sentry/react'

import { track } from '../../../services/analytics/analytics'
import { AUTH_FLOW } from '../../../services/analytics/auth-events'
import { getCookieByName, parseAndPrepareUtmCookie } from '../../../util/get-and-parse-cookie'

const SIGNUP_VARIATION = 'B_2025_06'

type SignupEventPayload = { [key: string]: string | string[] | number | boolean | undefined | null }

/**
 * The address being signed up with, stamped onto every event. Held on the module because most
 * events are reported from hooks that never see the address: a platform failure knows the
 * platform and nothing else.
 */
let signupEmail: string | undefined

export const setSignupEmail = (email?: string | null): void => {
  signupEmail = email ? email.toLowerCase() : undefined
}

/**
 * Every event carries the flow, so the two sign-up pages stay separable in reporting, and the
 * address once there is one. An explicit payload value wins over the stamped address.
 */
export const trackSignup = (eventName: string, payload: SignupEventPayload = {}): Promise<void> => track(eventName, { email: signupEmail, ...payload, authFlow: AUTH_FLOW })

export const trackSignupStarted = (platform: string): void => {
  let utmCookieDecoded
  const utmCookie = getCookieByName('_vt_sc')
  if (utmCookie) {
    try {
      utmCookieDecoded = parseAndPrepareUtmCookie(utmCookie)
    } catch (error) {
      Sentry.captureException(error)
    }
  }

  trackSignup('SIGNUP_STARTED', {
    platform,
    timestamp: new Date().toDateString(),
    source: 'app',
    signupVariation: SIGNUP_VARIATION,
    status: 'started',
    utmCookie: utmCookieDecoded,
  })
}

export const trackLoginCompleted = (platform: string): void => {
  trackSignup('LOGIN_COMPLETED', {
    platform,
    timestamp: new Date().toDateString(),
    source: 'app',
    signupVariation: SIGNUP_VARIATION,
    status: 'completed',
    // Reporting filters on this exact value, typo included.
    fromPage: 'singup',
  })
}
